<template>
  <v-app class="rounded">
    <v-container fluid>
      <v-card-title>
        <!--        <v-btn @click="$router.push({name: 'admin.campaign.create'})" class="btn-add-with-text">-->
        <!--          <v-icon>mdi-plus</v-icon>-->
        <!--          افزودن کمپین-->
        <!--        </v-btn>-->
        <!--        <v-spacer/>-->
        <!--        {{ $t($route.meta.title) }}-->
        <!--        <v-spacer/>-->
        <!--        <v-btn :loading="loading" @click="reloadTable(tableProps)" class="btn-update">-->
        <!--          <v-icon>mdi-refresh</v-icon>-->
        <!--          به روزرسانی-->
        <!--        </v-btn>-->
      </v-card-title>
      <v-divider />
      <div class="row">
        <div class="col-md-12 p-5">
          <data-table
            orderDir="desc"
            :data="data"
            :columns="columns"
            :debounce-delay="5000"
            :translate="translates"
            :per-page="perPages"
            @on-table-props-changed="reloadTable"
          >
            <div slot="filters" slot-scope="{ tableFilters, perPage }">
              <div class="row mb-2">
                <div class="col-md-4">
                  <v-select
                    v-model="tableFilters.length"
                    :items="perPage"
                    :filters="{ province: '' }"
                    item-value="page"
                    item-text="page"
                    outlined
                    dense
                  >
                  </v-select>
                </div>
              </div>
            </div>
          </data-table>
        </div>
      </div>
    </v-container>
    <v-dialog v-model="messageModal" persistent max-width="400px">
      <v-card>
        <v-card-title>
          <span class="text-h5">ارسال پیام</span>
          <v-spacer></v-spacer>
          <v-btn
            small
            icon
            rounded
            @click="messageModal = false"
            class="ml-1 text-danger"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <hr />
        <v-card-text>
          <br />
          <v-container>
            <v-row>
              <v-flex xs12 sm12 md12 lg12 xl12 class="p-2">
                <v-autocomplete
                  :items="messageCategories.data"
                  item-text="title"
                  v-model="category_id"
                  :loading="loadingCategory"
                  @change="getMessageQuery"
                  item-value="id"
                  clearable
                  outlined
                  dense
                  label="انتخاب دسته بندی"
                >
                  <template slot="item" slot-scope="{ item, tile }">
                    <div>{{ item.title }}</div>
                  </template>
                  <template slot="append-item">
                    <v-container>
                      <div class="text-center">
                        <v-pagination
                          v-model="page"
                          :length="messageCategories.last_page"
                          :total-visible="2"
                          circle
                        ></v-pagination>
                      </div>
                    </v-container>
                  </template>
                </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm12 md12 lg12 xl12 class="p-2" v-if="messages.data">
                <v-autocomplete
                  :items="messages.data"
                  dense
                  filled
                  clearable
                  item-text="title"
                  item-value="id"
                  :error-messages="messageError.id"
                  v-model="message"
                  label="عنوان پیام"
                >
                </v-autocomplete>
              </v-flex>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="btn-cancel" @click="messageModal = false">
            انصراف
          </v-btn>
          <v-btn class="submit-btn" @click="sendSms"> ارسال </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import Button from "@/view/pages/Button.vue";
import CheckboxFild from "@/view/pages/admin/users/CheckboxFild";
import UsernameBtn from "@/view/pages/admin/customers/UsernameBtn";
import Provinces from "@/Provinces.json";

export default {
  name: "Index",
  data() {
    return {
      provinces: [],
      category_id: "",
      search: "",
      page: 1,
      messageCategories: [],
      categoryUrl: "admin/campaign",
      query: {
        page: 1,
        search: "",
        length: 5,
      },
      columns: [
        {
          label: "ردیف",
          transform: (val) => {
            let row = this.data.current_page - 1;
            row = row * this.data.per_page;
            return row + val.row + 1;
          },
        },
        {
          label: "شناسه",
          name: "id",
          orderable: true,
        },
        {
          label: "عنوان",
          name: "name",
          orderable: true,
        },
        {
          label: "هدف",
          name: "user_type",
          transform: (val) => {
            return val.data.user_type == "customers" ? "مشتری" : "کاربر";
          },
        },

        {
          label: "وضعیت",
          name: "status",
          transform: (val) => {
            return this.$options.filters.status(val.data.status);
          },
        },
        {
          label: "تاریخ شروع",
          name: "started_at",
          transform: (val) => {
            return val.data.started_at
              ? this.$options.filters.longDate(val.data.started_at)
              : "شروع نشده!";
          },
        },
        {
          label: "مدیریت",
          name: "actions",
          component: Button,
          handler: this.actions,
          event: "action",
          meta: {
            permission_prefix: "user_",
            buttons: [
              {
                label: "ویرایش",
                name: "edit",
                icon: "pencil-alt",
                class: "btn-edit",
              },
            ],
          },
        },
      ],
      data: {},
      url: "admin/campaign",
      messageModal: false,
      selectedRows: [],
      tableProps: {
        search: "",
        length: 10,
        filters: {
          province: "",
        },
        column: "id",
        dir: "desc",
      },
      loading: false,
      loadingCategory: false,
      messages: [],
      messageError: [],
      message: null,
      timer: null,
    };
  },
  mounted() {
    this.getCampaigns();
    this.provinces = Provinces;
  },
  methods: {
    clearSearch() {
      this.search = "";
    },
    getMessageQuery() {
      console.log(this.search);
      if (this.category_id !== null) return this.getMessage(this.category_id);
      if (this.search !== null) return (this.messages = []);
    },
    getMessageCategories(url = this.categoryUrl, query = this.query) {
      if (query.search === null) this.$modal.showLoading();
      this.loadingCategory = true;
      this.requestApiGet(url, query)
        .then(({ data }) => {
          this.$modal.hideLoading();
          this.loadingCategory = false;
          this.messageCategories = data;
        })
        .catch(({ response }) => {
          this.loadingCategory = false;
          this.$modal.hideLoading();
        });
    },

    getUserCustomers(data) {
      this.$router.push({
        name: "admin.customers.owner",
        params: { user_id: data.user_id },
      });
    },

    sendSms() {
      this.$modal.showLoading();
      this.requestApiPost("customer/send-message", {
        id: this.message,
        customer_id: this.selectedRows,
      })
        .then(({ data }) => {
          this.$modal.hideLoading();
          this.messageModal = false;
          this.$toast.success("پیام برای مشتریان ارسال شد.");
        })
        .catch(({ response }) => {
          this.messageError = response.data.errors;
          this.$modal.hideLoading();
        });
    },
    getMessage(query) {
      this.requestApiGet(`customer/messages/${query}`)
        .then((data) => {
          this.$modal.hideLoading();
          this.messages = data;
        })
        .catch(({ response }) => {
          this.$modal.hideLoading();
        });
    },
    async showSms() {
      if (this.selectedRows.length === 0)
        return this.$toast.error("هیچ موردی انتخاب نشده است.");
      this.$modal.showLoading();
      await this.getMessageCategories();
      this.messageModal = true;
    },
    selectAll(c) {
      window.Vue.$emit("selectedAllCheckbox", c);
    },
    change(data, checked) {
      if (checked) {
        this.selectedRows.push(data.id);
      } else {
        let index = this.selectedRows.indexOf(data.id);
        this.selectedRows = [
          ...this.selectedRows.slice(0, index),
          ...this.selectedRows.slice(index + 1, this.selectedRows.length),
        ];
      }
      window.document.querySelector("#select_all").checked =
        this.selectedRows.length == this.data.data.length;
    },
    getCampaigns(url = this.url, query = this.tableProps) {
      if (query.search === "") this.$modal.showLoading();
      this.loading = true;
      this.requestApiGet(url, query)
        .then(({ data }) => {
          this.$modal.hideLoading();
          this.loading = false;
          this.data = data;
        })
        .catch(({ response }) => {
          this.$modal.hideLoading();
          this.loading = false;
        });
    },
    reloadTable(tableProps) {
      this.getCampaigns(this.url, tableProps);
    },
    actions(data, type) {
      this[type](data);
    },
    edit(data) {
      this.$router.push({
        name: "admin.campaign.edit",
        params: { id: data.id },
      });
    },
  },
  watch: {
    page(val) {
      this.query.page = val;
      console.log(val);
      this.getMessageCategories(this.categoryUrl, this.query);
    },
    search(val) {
      this.query.search = val;

      this.getMessageCategories(this.categoryUrl, this.query);
    },
  },
};
</script>

<style scoped></style>
